import { BookingPage } from "@/pages/BookingPage";
import { CustomerPage } from "./pages/CustomerPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { SitePage } from "./pages/SitePage";
import { LoginPage } from "./pages/LoginPage";
import { PlaylistPage } from "./pages/PlaylistPage"; 
import { OccupancyPage } from "./pages/OccupancyPage"; 
import { Routes, Route, Outlet } from "react-router-dom";
import { RmSidebar } from "./RmSidebar";
import { SiteHeader } from "./SiteHeader";
import { SpotPage } from "./pages/SpotPage";
import { UserPage } from "./pages/UserPage";
import { OrderPage } from "./pages/OrderPage";
import { MonitorPage } from "./pages/MonitorPage";

function AppLayout() {
  return (
    <>
      <SiteHeader />
      <div className="page-content flex">
        <RmSidebar />  
        <main className="w-full">
          <Outlet /> 
        </main>
      </div>
    </>
  )
}

function LoginPageLayout() {
  return (
    <div className="h-screen w-screen flex items-center justify-center">
      <LoginPage />
    </div>
  )
}

const App = () => {
  return (
    <Routes>
      <Route path="/auth" element={<LoginPageLayout />} >
      </Route>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<BookingPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="bookings" element={<BookingPage />} />
        <Route path="customer" element={<CustomerPage />} />
        <Route path="sites" element={<SitePage />} />
        <Route path="spots" element={<SpotPage />} />
        <Route path="orders" element={<OrderPage />} />
        <Route path="playlists" element={<PlaylistPage />} />
        <Route path="occupancy" element={<OccupancyPage />} />
        <Route path="users" element={<UserPage />} />
        <Route path="monitor" element={<MonitorPage />} />
      </Route>
    </Routes>
  );
};

export default App;
